import request from '@/utils/httpRequest'
/*
 * @author: xz
 * */
/*
 * @Description: 设置分享、浏览量
 * */
export function setAmount (query) {
  return request({
    url: '/api/communal/web/amount',
    method: 'PUT',
    data: query
  })
}

/*
 * @Description: 设置点赞
 * */
export function setupdateStar (query) {
  return request({
    url: '/api/personal/web/personal/updateStar',
    method: 'PUT',
    data: query
  })
}

/*
 * @Description: 设置收藏
 * */
export function setupdateCollect (query) {
  return request({
    url: '/api/personal/web/personal/updateCollect',
    method: 'PUT',
    data: query
  })
}

/*
 * @Description: 获取点赞、收藏、分享、浏览量
 * */
export function getAmount (id, menuId, query) {
  return request({
    url: '/api/communal/web/amount/' + id + '/' + menuId,
    method: 'get',
    params: query
  })
}

// 获取列表页的点赞收藏等数据（所有的）

export function getListAmount (menuId, query) {
  return request({
    url: '/api/communal/web/amount/' + menuId,
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/datavolume/index.js